const applyTransparency = (col: number, alpha: number, bgCol = 255) => col * alpha + bgCol * (1 - alpha);

/**
 * @deprecated Use `alpha` from `@mui/material` instead. If `native-base`, reference here
 * https://docs.nativebase.io/utility-props
 */
export const hexToRgbA = (hex: string, alpha = 1, applyAlpha?: boolean) => {
  const defaultOutput = 'transparent'; // Could be null or falsy value too

  if (!hex) {
    return defaultOutput;
  }

  const hexMatch = hex.match(/\w\w/g);

  if (!Array.isArray(hexMatch)) {
    return defaultOutput;
  }

  const [r, g, b] = hexMatch.map((x) => parseInt(x, 16));

  if (applyAlpha) {
    const newR = applyTransparency(r, alpha);
    const newG = applyTransparency(g, alpha);
    const newB = applyTransparency(b, alpha);
    return `rgb(${newR},${newG},${newB})`;
  }

  return `rgba(${r},${g},${b},${alpha})`;
};
